export default __webpack_public_path__ + "static/media/apple-store.15f01eef.svg";